import React from "react"

import { useFormikContext } from "formik"

import { AlertMessageBox } from "~tailwindui/Basics"

const FormStatus = () => {
  const { status, errors } = useFormikContext()

  return (
    <div className="mt-8">
      {(status || Object.keys(errors).length > 0) && (
        <AlertMessageBox>
          {status || "Please fix validation errors above"}
        </AlertMessageBox>
      )}
    </div>
  )
}

export default FormStatus
